import {Grid, GridProps, ScrollArea, Table, Text} from "@mantine/core";
import {Entity, useGetEntityIntegrationHistory} from "@ots-frontend/ots-data";
import {FormattedDateTime} from "../../../date/FormattedDateTime/FormattedDateTime";

export type EntityIntegrationStatusViewProps = Omit<GridProps, 'children'> & {
  entity: Entity
}

export const EntityIntegrationStatusView = (props: EntityIntegrationStatusViewProps) => {
  const {
    entity,
    ...rest
  } = props

  const {history} = useGetEntityIntegrationHistory({entity: entity});

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <ScrollArea>
          <Table striped highlightOnHover>
            <thead>
            <tr>
              <th>Type</th>
              <th>Status</th>
              <th>Timestamp</th>
              <th>Description</th>
            </tr>
            </thead>
            <tbody>
            {history &&
              <>
                {history.map((hist) => {
                    let index = 0
                    return (
                      <tr key={index++}>
                        <td>{hist.type}</td>
                        <td>{hist.status}</td>
                        <td>
                          <FormattedDateTime date={hist.statusDttm}/>
                        </td>
                        <td>
                          {hist.description ? (
                            <Text color="dimmed">{hist.description}</Text>
                          ) : (
                            <Text color="dimmed">—</Text>
                          )}
                        </td>
                      </tr>
                    )
                  }
                )}
              </>
            }
            </tbody>
          </Table>
        </ScrollArea>
      </Grid.Col>
    </Grid>
  )
}
